import React from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'

import Loader from 'components/loaders/Loader/Loader'

import s from './OverlayLoader.scss'


const OverlayLoader = ({ isVisible, name }) => isVisible && (
  <Portal>
    <Loader className={s.overlayLoader} name={name} />
  </Portal>
)

OverlayLoader.propTypes = {
  isVisible: PropTypes.bool,
}

OverlayLoader.defaultProps = {
  isVisible: true,
}


export default OverlayLoader
